var map = {
	"./HowCanIGetASafeTanHowDoIChooseTheRightSunBlock.md": [
		642,
		642
	],
	"./IveNeverBeenWaxedBeforeHowIsItDone.md": [
		997,
		997
	],
	"./PrivacyPolicy.md": [
		914,
		914
	],
	"./Special.md": [
		808,
		808
	],
	"./WhatIsAFacialWhyDoINeedOne.md": [
		318,
		318
	],
	"./WhatIsBraziliamWaxing.md": [
		356,
		356
	],
	"./WhatsIsAChemicalPeel.md": [
		355,
		355
	],
	"./WhyShouldISeeAnEsthetician.md": [
		974,
		974
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 186;
module.exports = webpackAsyncContext;